import React from 'react'
import { withRouter } from 'react-router-dom';
import withAuthentication from './identity/withAuthentication';

import {Row} from 'react-materialize'

import * as routes from '../config/routes';
import * as api from '../api'

import * as proposalCopy from '../assets/copy/proposal'
import * as proposalLogic from '../assets/copy/dynamicProposalV2'
import * as generalCopy from '../assets/copy/general'

import CheckboxInput  from './CheckboxInput'
import SelectInput from './SelectInput'
import RadioInput from './RadioInput'

import jQuery from 'jquery'

import mixpanel from 'mixpanel-browser';
import Nouislider from 'react-nouislider';
import 'nouislider/distribute/nouislider.css';

mixpanel.init("ddd5fe63eecdfbaa821d5d54182df527");





require('../assets/styles/formstyle.css');
require('../assets/scripts/nice-select.js');

class GetStarted extends React.Component {
  state = {
    form: {},
    step: 0, 
    currentUserName: "Admin (Let's start with you)",
    userTypes: [{role: "Admin (Let's start with you)"}],
    min: 75,
    max:200
  }

  constructor (props) {
    super(props)
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    window.startSelect(jQuery)
    this.mixpanelTrack('Visit')
    this.clearRequired()
  }

  mixpanelTrack = (message) => {
    mixpanel.track('Proposal: ' + message);
  }

  componentDidUpdate() {
    window.applySelect(jQuery, this.valueHelper)
  }

  submitForm(e) {
    e.preventDefault()
    this.setState({submitting: true})
    this.mixpanelTrack('Submit Try')
    if (!this.isQuestionEmpty('namequestion')) {
      if (!this.isQuestionEmpty('company')) {
        if (!this.isQuestionEmpty('emailq')) {
          if(this.validateEmail(this.state.form.emailq)) {
            var formBody = this.state.form
            formBody['users'] = this.state.userTypes
            formBody['min'] = this.state.min
            formBody['max'] = this.state.max
            api.makeApiPost(routes.INTAKE_FORM, formBody, (res, status) => {
                if (res.err || status !== 200) {
                  this.mixpanelTrack('Submit Error')
                  this.setState({step: "error"})
                } else {
                  this.mixpanelTrack('Submit Success')
                  this.setState({form: {}, userTypes: {}})
                  this.setState({step: "done"})
                }
                this.setState({submitting: false})
            })
          } else {
            this.setState({submitting: false, namequestion: true, emailq: true, invalidEmail: true})
          }
        } else {
          this.setState({submitting: false, namequestion: true, emailq: false, company: true})
        }
      } else {
        this.setState({submitting: false, namequestion: true, company: false})
      }
    } else {
      this.setState({submitting: false, namequestion: false})
    }
      
  }

  validateEmail = (email) => {
   return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
  }

  checkboxHelper = (event, question_id) => {
    var el
    if (event)
      el = event.target
    if (el) {
      this.mixpanelTrack('Checkbox: ' + question_id + " " + el.id + " " + el.checked)
      var newForm = this.state.form
      newForm[el.id] = el.checked
      this.setState({form: newForm})
    }
  }

  addUserType() {
    this.setState({
      question7_0: true,
      question7_1: true
    }) 
    if(this.state.currentUserName) {
      if (this.state.currentUserSize) {
        var roles = this.state.userTypes
        var newRole = {role: this.state.currentUserName, size: this.state.form.rolesize}
        roles[roles.length - 1] = newRole
        roles.push({role: ""})
        this.mixpanelTrack('Add User: ' + newRole)
        this.setState({userTypes: roles, currentUserSize: "", currentUserName: ""})
      } else {
        this.setState({question7_0: false, currentUserSize: ""})

      }
    } else {
      this.setState({question7_1: false, currentUserName: ""})
    }
  }

  removeUser = (e, index) => {
    this.mixpanelTrack('Remove User')
    this.state.userTypes.splice(index, 1)
    var newUserTypes = this.state.userTypes
    this.setState({userTypes: newUserTypes})
  }

  currentUserRole = (e) => {
    this.setState({currentUserName: e.target.value});
  }

  valueHelper = (event) => {
    var el
    if (event)
      el = event.target
    if (el) {
      this.mixpanelTrack('Input: ' + el.id + " " + el.value)
      var newForm = this.state.form
      newForm[el.id] = el.value
      this.setState({form: newForm})
      if (el.id === "rolesize") {
        this.setState({currentUserSize: el.value});
      }
    }
  }

  isQuestionEmpty = (questionId) => {
    return proposalLogic.sections[this.state.step].questions.map((question) => {
      if (question.id === questionId) {
        if (this.isHidden(question)) {
          return false
        }
        var hasElement = false
        if (question.options) {
          var optionsArray = question.options.map((option) => {
            return this.state.form[option.id] || this.state.form[question.id] === option.id 
          })
          hasElement = optionsArray.includes(true)
        } else if (["url_input", "input", "email", "textarea"].includes(question.type)) {
          hasElement = this.state.form[question.id] !== undefined && this.state.form[question.id] !== ""
        }
        return !hasElement
      }
    }).includes(true)
  }

  usersEmpty = () => {
    return this.state.userTypes[0].size === undefined
  }

  clearRequired = () => {
    proposalLogic.sections[this.state.step].questions.map((question) => {
        var obj = {}
        obj[question.id] = true
        this.setState(obj)
        return obj
      })
  }

  changeState = () => {
    this.setState({step: this.state.step + 1}, () => {
      this.clearRequired()
    })
  }

  nextStep = () => {
    this.mixpanelTrack('Next Step - ' + this.state.step)
    this.clearRequired()

    if (this.state.step === 1) {
      if (!this.usersEmpty()) {
        this.setState({step: this.state.step + 1})
        return
      } else {
        this.setState({question7_0: false})
        return
      }
    }
    var questionsInSection = proposalLogic.sections[this.state.step].questions
    for (var index in questionsInSection) {
      var question = questionsInSection[index]
      var empty = this.isQuestionEmpty(question.id)
      if (empty) {
        var obj = {}
        obj[question.id] = false
        this.setState(obj)
        return
      }
    }
    this.changeState()
  }

  isHidden = (question) => {
    if (this.state.step === 1 && undefined === question.tag) {
      return false 
    }
    if (this.state.form['needs'] == question.tag) {
      return false
    }
    if ((question.tag !== undefined && (this.state.form[question.tag] === undefined || this.state.form[question.tag] === false)) 
    || (this.state.step === 1 && (this.state.form[question.tag] === "na" || this.state.form[question.tag] === "none" || this.state.form[question.tag] === undefined)) ) {
      return true
    }
    return false
  }

  render() {
    return (
      <div className="full-height valign-wrapper">
      <div className="container ">
      <div className="section">
      <div className="container-fluid full-height">
      <div className="row row-height">
      <div className="col-lg-12 content-right" id="start">
      <div id="wizard_container">
        <div id="top-wizard">
          <div id="progressbar"></div>
        </div>
        <form id="wrapped" method="POST" >

          {this.state.step + 1 <= proposalLogic.sections.length ? 
          (<div className="step">
  
            <h3 className="main_question"><strong>{this.state.step + 1}/{proposalLogic.sections.length}</strong>{proposalLogic.sections[this.state.step].title}</h3> 
            <p>{proposalLogic.sections[this.state.step].description}</p>
          {proposalLogic.sections[this.state.step].questions.map((question, index) => {
            if (this.isHidden(question)) {
              return
            }
            
            if (question.type === "checkbox") {
              return <CheckboxInput
                id={question.id} 
                required={!this.state[question.id]}
                handler={this.checkboxHelper} 
                question={question.prompt} 
                question_options={question.options} 
                selection={this.state.form} />
            }
            if (question.type === "radio") {
              return <RadioInput
                id={question.id} 
                required={!this.state[question.id]}
                handler={this.checkboxHelper} 
                question={question.prompt} 
                question_options={question.options} 
                selection={this.state.form} />
            }
            if (question.type === "select") {
              return <SelectInput 
                id={question.id} 
                handler={this.valueHelper} 
                required={!this.state[question.id] && !(this.state[question.id] === undefined)}
                question={question.prompt} 
                question_options={question.options}  
                selection={this.state.form[question.id]} />
            }
            if (question.type === "url_input") {
                return <div className="form-group"><input 
                  id={question.id} 
                  onChange={this.valueHelper} 
                  type="url" 
                  className="form-control" 
                  placeholder={question.prompt} 
                  defaultValue = {this.state.form[question.id]}
                  />
                  {(this.state[question.id] === false) ? 
                  (<span className="error">Required</span>) : false}
                  </div>
            }
            if (question.type === "input") {
                return <div className="form-group"><input 
                  id={question.id} 
                  onChange={this.valueHelper} 
                  type="text" 
                  className="form-control" 
                  placeholder={question.prompt} 
                  defaultValue = {this.state.form[question.id]}
                  />
                  {(this.state[question.id] === false) ? 
                  (<span className="error">Required</span>) : false}
                  </div>
            }
            if (question.type === "email") {
                return <div className="form-group"><input 
                  id={question.id} 
                  onChange={this.valueHelper} 
                  type="email" 
                  className="form-control" 
                  placeholder={question.prompt} 
                  defaultValue = {this.state.form[question.id]}
                  />
                  {(this.state[question.id] === false) ? 
                  (<span className="error">Required</span>) : false}
                  {(this.state['invalidEmail'] === true) ? 
                  (<span className="error">Valid Email Required</span>) : false}
                  </div>
            }
            if (question.type === "textarea") {
              return <div className="form-group">
                  <textarea 
                    id={question.id}
                    onChange={el => this.valueHelper(el)} 
                    placeholder={question.prompt} 
                    className="form-control"
                    defaultValue = {this.state.form[question.id]}
                    ></textarea>
                  {(this.state[question.id] !== undefined ? !this.state[question.id] : false) ? 
                    (<span className="error">Required</span>) : false}
              </div>
            }

          })}

           { (this.state.step === 0) ? (
          		<div id="connect">
          		<p>What is your budget?
          		<span className="budget">${this.state.min}k - ${this.state.max}k</span></p>
			    <Nouislider
			    	onSlide={(data)=> {
			    		this.setState({min: parseInt(data[0])})
			    		this.setState({max: parseInt(data[1])})

			    	}}
				    range={{min: 50, max: 500}}
				    start={[this.state.min, this.state.max]}
				    step={5}
				    connect={true}
				    orientation='horizontal'
				    
				  /></div>

          	): null}

          { (this.state.step === 1) ? (
            <div>

            {this.state.userTypes.map((option, index) => {
                var question = proposalLogic.sections[this.state.step].questions[0]
                if (index !== this.state.userTypes.length - 1) {
                  return <div>
                    <p className="user-box"><strong>{"User Role #" + (index + 1) + ": "}</strong>{option.role} 
                    <br/>
                    {index === 0 ? false : <a className="remove-user gray-x" onClick={el => this.removeUser(el, index)}>M</a>}
                    {option.size}
                  </p><br/></div>
                } else {
                    return (
                      <div>
                      <br/>
                      <div className="form-group">
                      {option.role === "" ? (
                        <input 
                          id="rolename" 
                          onChange={this.currentUserRole} 
                          type="text" 
                          className="form-control" 
                          placeholder="User Role"  
                          defaultValue={this.state.currentUserName}
                          />
                          ):
                          <input 
                          id="rolename" 
                          onChange={this.currentUserRole} 
                          type="text" 
                          className="form-control" 
                          placeholder="User Role"  
                          defaultValue={option.role}
                          />
                      }
                      {(this.state.question7_1 !== undefined ? !this.state.question7_1 : false) ? 
                      (<span className="error">Required</span>) : false}
                      
                      </div>
                      <div className="form-group">
                      <div className="styled-select clearfix">
                          <select id = "rolesize" required className="wide" value={this.currentUserSize} >
                              <option selected disabled hidden>{proposalCopy.question7} </option>
                            {
                                question.options.map((option, index) => {
                                  return (<option key={index} value={option.text} >{option.text}</option>)
                              }
                            )}
                          </select>
                          {(this.state.question7_0 !== undefined ? !this.state.question7_0 : false) ? <span className="error">Required</span> : false}
                      </div>
                      </div>
                      
                      </div>

                )}
              })
                
            }
              <div className="form-group">
              <button type="button" 
                className="plus" 
                onClick={() => {this.addUserType()}}>Add user</button>
              </div>
              </div>
             
            ) : false 
          }

          <p className="nda">{proposalLogic.sections[this.state.step].nda}</p>
          <div id="bottom-wizard">
          {this.state.step !== 0 ? <button type="button" name="backward" className="backward" onClick={() => {this.setState({step: this.state.step - 1})}} >Prev</button> : false }
          {this.state.step + 1 !== proposalLogic.sections.length ? <button type="button" name="forward" className="forward" onClick={this.nextStep} >Next</button> : false }
          {this.state.step + 1 === proposalLogic.sections.length ? <button disabled = {this.state.submitting} type="submit" name="process" className="submit" onClick={this.submitForm}>Submit</button> : false }
          </div>
          </div>
          ) : false }
          
          { (this.state.step === "done") ? (
          <div className="card-panel">
          <br/>
          <h5 className=" main_question secondary-color-1-text "> {generalCopy.thanks} </h5>
          <p className="mid-size-h center-align">We'll get to work on your customized roadmap. In the meantime, you can <a className='link' href='https://calendly.com/gib/lets'>click here to schedule a convenient time</a> to hear all about it.</p>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>

          </div>
          ) : false }
          { (this.state.step === "error") ? (
          <div className="card-panel">
          <br/>
          <h5 className=" main_question secondary-color-1-text "> {generalCopy.problem}</h5>
          <p className="mid-size-h center-align">{generalCopy.problemDetail}</p>
          <hr className="center-align secondary-color-2 secondary-color-2-text"/>

          <Row>
          <p className="center-align">
          <a onClick={() => {this.setState({step:0})}} className="btn" >{generalCopy.tryAgain}</a>
          </p>
          </Row>
          </div>
          ) : false }

        </form>
      </div>
      </div>
      </div>
      </div>
      </div>
      </div>
      </div>
    );
  }
}

export default withRouter(withAuthentication(GetStarted));


// WEBPACK FOOTER //
// ./src/components/GetStarted.js